import { render } from "./SegmentedSelect.vue?vue&type=template&id=1106b9f4&scoped=true"
import script from "./SegmentedSelect.vue?vue&type=script&lang=js"
export * from "./SegmentedSelect.vue?vue&type=script&lang=js"

import "./SegmentedSelect.vue?vue&type=style&index=0&id=1106b9f4&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1106b9f4"]])

export default __exports__